"use client";
import { ApiConstant } from "@/const";
import { IDataResponseModel, StatusTypeEnum } from "@/models";
import {
  deleteSysTable,
  patchSysTableStatus,
  postSysTable,
  postReturnIdSysTable,
  putSysTable,
  patchSysTable,
} from "@/services/sysTable.service";
// import { revalidatePath } from "next/cache";

const deleteSysTableAction = async (urlDelete: string): Promise<string> => {
  const res = await deleteSysTable(urlDelete);
  if (res.status === ApiConstant.STT_OK) {
    // if (urlValidatePath) revalidatePath(urlValidatePath);
    return "";
  } else {
    return res.payload.message || "Xóa không thành công";
  }
};

const patchSysTableStatusAction = async (
  urlPatchStatus: string,
): Promise<string> => {
  const res = await patchSysTableStatus(urlPatchStatus);
  if (res.status === ApiConstant.STT_OK) {
    // if (urlValidatePath) revalidatePath(urlValidatePath);
    return "";
  } else {
    return res.payload.message || "Đổi trạng thái không thành công";
  }
};

const postSysTableAction = async (
  formData: object,
  apiUrlCreate: string,
  urlValidatePath?: string,
): Promise<string> => {
  const res = await postSysTable(formData, apiUrlCreate);
  if (res.status === ApiConstant.STT_OK) {
    // if (urlValidatePath) revalidatePath(urlValidatePath);
    return "";
  } else {
    return res.payload.message || "Đã có lỗi xảy ra";
  }
};
const postSysTableReturnIdAction = async (
  formData: object,
  apiUrlCreate: string,
): Promise<IDataResponseModel<string>> => {
  return await postReturnIdSysTable(formData, apiUrlCreate);
};
const putSysTableAction = async (
  formData: object,
  apiUrlUpdate: string,
  urlValidatePath?: string,
): Promise<string> => {
  const res = await putSysTable(formData, apiUrlUpdate);
  if (res.status === ApiConstant.STT_OK) {
    // if (urlValidatePath) revalidatePath(urlValidatePath);
    return "";
  } else {
    return res.payload.message || "Đã có lỗi xảy ra";
  }
};
const patchSysTableAction = async (
  formData: object,
  apiUrlCreate: string,
): Promise<string> => {
  const res = await patchSysTable(formData, apiUrlCreate);
  if (res.status === ApiConstant.STT_OK) {
    return "";
  } else {
    return res.payload.message || "Đã có lỗi xảy ra";
  }
};
export {
  deleteSysTableAction,
  patchSysTableStatusAction,
  putSysTableAction,
  postSysTableAction,
  postSysTableReturnIdAction,
  patchSysTableAction,
};
